import React from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import { Grid } from "@material-ui/core";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import ErrorIcon from '@material-ui/icons/Error';

export default function AlertDialog({ text, open, handleClose, color }) {
  let red = "#B00020";
  let green = "#37C846";
  let alertColor = (color === "red") ? red : green;

  return (
    <Dialog
      fullWidth={true}
      maxWidth={"md"}
      open={open}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      {/* <DialogTitle id="alert-dialog-title">Atención</DialogTitle> */}
      <DialogContent style={{ backgroundColor: alertColor }}>
        <Grid container spacing={1}>
          <Grid item xs={9}>
            <DialogContentText
              id="alert-dialog-description"
              style={{ color: "#ffffff", display: 'flex', alignItems: 'center'}}
            >
                {(color === "red") ? <ErrorIcon/> : <CheckCircleIcon />}
                &nbsp;&nbsp;
                {text}
            </DialogContentText>
          </Grid>
          <Grid item xs={3} justify="flex-end">
            <Button
              onClick={handleClose}
              style={{
                backgroundColor: alertColor,
                color: "#ffffff",
                border: "1px solid #ffffff",
              }}
              autoFocus
              variant="contained"
            >
              Aceptar
            </Button>
          </Grid>
        </Grid>
      </DialogContent>
      {/* <DialogActions>
          
        </DialogActions> */}
    </Dialog>
  );
}
